export const FORM_STRINGS = {
  search: {
    public: 'publico',
    publicGeneral: 'publico general',
  },
  payment: {
    condon: 'CONDON',
    efectivo: 'EFECTIVO',
    credito: 'CREDITO',
    sgcSkip: 'skip',
  },
  unitTypes: {
    p: '_P',
    e: '_E',
    anden: 'ANDEN',
    mayor: 'MAYOR',
  },
  unitMeasure: {
    kilos: 'KILOS',
  },
  labels: {
    date: 'Fecha',
    loading: 'Cargando...',
    accounts: 'Cuentas',
    searchAccount: 'Buscar Cuenta',
    account: 'Cuenta',
    station: 'Planta',
    unit: 'Unidad',
    product: 'Producto',
    quantity: 'Cantidad',
    cil10: 'Cil 10',
    cil20: 'Cil 20',
    cil30: 'Cil 30',
    cil45: 'Cil 45',
    kgsBulk: 'Kgs a Granel',
    lts: 'Cantidad de LTS',
    unitPriceLt: 'Precio Unitario Lt',
    unitPriceKg: 'Precio Unitario Kg',
    retention: "Retención",
    totalByProduct: 'Total por producto',
    paymentMethod: 'Metodo de pago',
    discount: 'Descuento',
    total: 'Total a Pagar',
    retentions: "Retenciones",
    liqTotal: "Total liquidación",
    currency: 'MXN',
    sgcSelect: 'Seleccionar SGC',
    sgc: 'SGC',
    retTotal: "Total a pagar",
    withholding: "Retención",
  },
  placeholders: {
    searchCustomer: 'Ingrese Nombre ',
  },
  noOptions: {
    customer: 'No se encuentra el Cliente',
    unit: 'No se encuentra la Unidad',
    paymentMethod: 'No se encuentra el metodo de pago',
    sgc: 'No se encuentra el SGC',
  },
  buttons: {
    publicGeneral: 'Publico General',
    close: 'Cerrar',
    cancel: 'Cancelar',
    confirm: 'Confirmar',
  },
  messages: {
    pendingBonuses: 'Es necesario confirmar las bonificaciones correspondientes para enviar al SGC',
    notWholesaler: 'La cuenta seleccionada no es mayorista: no aplican unidades asignadas ni retenciones',
    validatingInventory: 'Validando estatus del inventario...',
  },
}